// extracted by mini-css-extract-plugin
export default {"container":"Dropzone_container__uV6o3","dropzone":"Dropzone_dropzone__o13AF","disabled":"Dropzone_disabled__8DU-T","center":"Dropzone_center__F1g5O"};